export default "__VITE_ASSET__723fc1a7__"